import React from 'react'
import Icon from '../../../../ui/Icon/Icon'
import styles from './OrderDeliveryInfo.module.scss'

const DELIVERY_TYPE_CONFIG = {
  stock: {
    title: 'Доставка у відділення НП',
    icon: 'box-heart',
  },
  currier: {
    title: 'Курʼєрська доставка',
    icon: 'truck',
  },
  pickup: {
    title: 'Самовивіз',
    icon: 'store',
  },
}

function OrderDeliveryInfo({ type, fullAddress, city, address, ttn }) {
  const config = DELIVERY_TYPE_CONFIG[type]

  if (!config) return null

  return (
    <div className={styles.root}>
      <div className={styles.iconWrap}>
        <Icon name={config.icon} className={styles.icon} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{config.title}</div>
        {city && <div className={styles.line}>Місто: {city}</div>}
        {address && <div className={styles.line}>Склад №: {address}</div>}
        {fullAddress && <div className={styles.line}>Адреса: {fullAddress}</div>}
        <div className={styles.line}>ТТН: {ttn ? ttn : '-'}</div>
      </div>
    </div>
  )
}

export { DELIVERY_TYPE_CONFIG }
export default OrderDeliveryInfo
